import React, { useState } from "react";
import CardWithTitle from "../../components/cards/card-width-title/CardWithTitle";
import DragNDrop from "../../components/drag-n-drop/DragNDrop";
import { Alert, Row, Container, Col, Button } from "shards-react";
import XLSX from "xlsx";
import MiniAppService from "../../services/mini-app-service/MiniAppService";
import { MiniAppDiffTable, MiniAppTitle, TitleHelper } from "./styled";
import Data from "../../data/Data";
import AuthService from "../../services/auth-service/AuthService";
import MiniAppAttributes from "./MiniAppAttributes";
import ToggleLink from "./ToggleLink";
import ShowValue from "./ShowValue";
import Loading from "../../components/loading/Loading";
import AxiosService from "../../services/axios-service/AxiosService";
import Storage from "../../services/storage-service/Storage";

const MassiveMiniappUpdate = () => {
    const [miniAppsToCreate, setMiniAppsToCreate] = useState([]);
    const [miniAppsToUpdate, setMiniAppsToUpdate] = useState([]);
    const [miniAppsToInform, setMiniAppsToInform] = useState([]);
    const [message, setMessage] = useState("");
    const [showMiniAppsEq, setShowMiniAppEq] = useState(false);
    const [isFetching, setFetching] = useState(false);
    const [alertTheme, setAlertTheme] = useState("light");
    const [alertVisible, setAlertVisible] = useState(false);
    const toggleShowMiniAppsEq = () => {
        setShowMiniAppEq(!showMiniAppsEq);
    };

    const compareMiniapps = async (data, readtype) => {
        setFetching(true);
        const miniAppsFromUser = readxUserMiniAppsFromXlsxData(data, readtype);
        const slugs = miniAppsFromUser.map(m => m.slug);
        // find by slug so para voltar todas as tags, no endpoint que lista todos os miniapps so vem uma tag...
        const miniAppsFromApiPromise = slugs.map(slug =>
            MiniAppService.findMiniAppBySlug(slug).catch(() => null)
        );
        const miniAppsFromApi = await Promise.all(miniAppsFromApiPromise);
        const miniAppFromApiBySlug = {};
        miniAppsFromApi
            .filter(m => m)
            .forEach(miniApp => {
                miniAppFromApiBySlug[miniApp.slug] = miniApp;
            });
        const miniAppsEq = [];
        const newMiniApps = [];
        const miniAppDifferences = [];
        miniAppsFromUser.forEach(miniAppFromUser => {
            miniAppFromUser.privacy = JSON.parse(miniAppFromUser.privacy);
            const miniAppFromAPI = miniAppFromApiBySlug[miniAppFromUser.slug];
            if (!miniAppFromAPI) {
                newMiniApps.push(miniAppFromUser);
            } else {
                const diff = MiniAppService.compareMiniapps(
                    miniAppFromAPI,
                    miniAppFromUser
                );
                if (diff.hasChanges) {
                    miniAppDifferences.push(diff);
                } else {
                    miniAppsEq.push(miniAppFromUser);
                }
            }
        });
        setMiniAppsToInform(miniAppsEq);
        setMiniAppsToCreate(newMiniApps);
        setMiniAppsToUpdate(miniAppDifferences);
        setFetching(false);
    };

    const parseToArrayOfStrings = itemsSeparatedWithDot => {
        return (itemsSeparatedWithDot || "")
            .split(/\./)
            .filter(item => item)
            .sort();
    };

    const parseToBoolean = excelValue => {
        if (excelValue === "" || typeof excelValue === "undefined") {
            return;
        }
        if (excelValue === "true") {
            return true;
        }
        if (excelValue === "false") {
            return false;
        }
        return !!excelValue;
    };

    const parseToJson = excelString => {
        if (typeof excelString === "undefined") {
            return;
        }
        const jsonFromExcel = excelString.replace(/[“”]/g, '"');
        return JSON.parse(jsonFromExcel);
    };

    const readxUserMiniAppsFromXlsxData = (data, readtype) => {
        const workbook = XLSX.read(data, readtype);
        const miniAppsFromXlsx = XLSX.utils
            .sheet_to_json(workbook.Sheets[workbook.SheetNames[0]])
            .filter(item => item);
        const miniAppsFromUser = miniAppsFromXlsx.map(miniApp => {
            const tags = parseToArrayOfStrings(miniApp.tags);
            const keywords = parseToArrayOfStrings(miniApp.keywords);
            const iosData = parseToJson(miniApp.iosData);
            const androidData = parseToJson(miniApp.androidData);
            const userMiniApp = {
                ...miniApp,
                tags,
                keywords,
                iosData,
                androidData
            };
            const visible = parseToBoolean(miniApp.visible);
            if (typeof visible === "boolean") {
                userMiniApp.visible = visible;
            }
            return userMiniApp;
        });
        return miniAppsFromUser;
    };

    const resetAlert = () => {
        setMessage("");
        setAlertVisible(false);
        setAlertTheme("light");
    };

    const resetScreenData = () => {
        resetAlert();
        setMiniAppsToCreate([]);
        setMiniAppsToUpdate([]);
        setMiniAppsToInform([]);
    };

    const onXlsxDrop = (data, readtype) => {
        resetScreenData();
        compareMiniapps(data, readtype);
    };

    const onXlsxProductDrop = async files => {
        try {
            setFetching(true);
            resetAlert();
            let token = Storage.get(Storage.KEYS.USERTOKEN);
            const config = {
                headers: { Authorization: "Bearer " + token }
            };
            const formData = new FormData();
            formData.append("productsFile", files[0], "products_file.xlsx");
            await AxiosService.httpPost(
                `${process.env.REACT_APP_MANAGER_BFF_URL}/v1/product`,
                formData,
                config
            );
            setMessage(
                "Produtos atualizados! Não se esqueça de enviar os dados para a RR."
            );
            setAlertTheme("success");
            setAlertVisible(true);
        } catch (e) {
            console.error(e);
            setAlertVisible(true);
            if (e && e.response && e.response.status === 403) {
                setMessage(
                    "Você não possui permissão para enviar os dados de produtos."
                );
            } else {
                setMessage("Erro ao atualizar os dados de produtos.");
            }
            setAlertTheme("danger");
        }
        setFetching(false);
    };

    const callExportAerosmith = async () => {
        try {
            setFetching(true);
            resetAlert();
            let token = Storage.get(Storage.KEYS.USERTOKEN);
            const config = {
                headers: { Authorization: "Bearer " + token }
            };

            await AxiosService.httpPost(
                `${process.env.REACT_APP_MANAGER_BFF_URL}/v1/export`,
                {},
                config
            );
            setMessage(
                "Informações enviadas para a Rich Relevance com sucesso!"
            );
            setAlertTheme("success");
            setAlertVisible(true);
        } catch (e) {
            console.error(e);
            setAlertVisible(true);
            if (e && e.response && e.response.status === 403) {
                setMessage(
                    "Você não possui permissão para enviar os dados para a Rich Relevance."
                );
            } else {
                setMessage("Erro ao atualizar a Rich Relevance.");
            }
            setAlertTheme("danger");
        }
        setFetching(false);
    };

    const createTagsToUpdate = miniAppDiff => {
        const defaultTag = miniAppDiff.current.tags.find(
            tag => tag.name === "default"
        );
        let tags = [];
        if (defaultTag) {
            tags.push(defaultTag);
        } else {
            // o back deveria garantir que essa tag existe
            tags.push({ name: "default", weight: 1000 });
        }
        if (miniAppDiff.changes.tags) {
            miniAppDiff.changes.tags.forEach(tagName => {
                tags.push({ name: tagName, weight: 1000 });
            });
        } else {
            tags = miniAppDiff.current.tags;
        }
        return tags;
    };

    const createMiniAppData = miniApp => {
        const createMiniApp = { ...miniApp, tags: [] };
        if (typeof createMiniApp.visible === "undefined") {
            createMiniApp.visible = true;
        }
        if (typeof createMiniApp.type === "undefined") {
            createMiniApp.type = Data.getAppTypes().EITRI_TYPE_ENGINE;
        }
        if (typeof createMiniApp.status === "undefined") {
            createMiniApp.status = Data.getMiniAppStatus().STATUS_ACTIVE;
        }
        createMiniApp.permissions = [];
        createMiniApp.autoCapture = false;
        createMiniApp.customerIdentityValidationEnabled = false;
        createMiniApp.customerIdentityValidationOcrEnabled = false;
        createMiniApp.organization = {
            name: "Calindra",
            owner: {
                email: AuthService.getDecodedToken().email
            }
        };
        if (miniApp.tags) {
            miniApp.tags.forEach(tagName => {
                createMiniApp.tags.push({ name: tagName, weight: 1000 });
            });
        }
        return createMiniApp;
    };

    const callBackendToCreateOrUpdate = async () => {
        try {
            setFetching(true);
            resetAlert();
            const updatePromises = miniAppsToUpdate.map(miniAppDiff => {
                let editMiniApp = {
                    ...miniAppDiff.current,
                    ...miniAppDiff.changes
                };
                editMiniApp.tags = createTagsToUpdate(miniAppDiff);
                return MiniAppService.updateMiniApp(editMiniApp);
            });
            await Promise.all(updatePromises);
            const createPromises = miniAppsToCreate.map(miniApp => {
                const createMiniApp = createMiniAppData(miniApp);
                return MiniAppService.createMiniApp(createMiniApp);
            });
            await Promise.all(createPromises);
            setMessage("MiniApps criados e atualizados com sucesso");
            setAlertTheme("success");
            setAlertVisible(true);
        } catch (e) {
            console.error(e);
            setAlertVisible(true);
            if (e && e.message) {
                setMessage(`Erro ao atualizar/criar os miniapps: ${e.message}`);
            } else {
                setMessage("Erro ao atualizar/criar os miniapps.");
            }
            setAlertTheme("danger");
        }
        setFetching(false);
    };

    return (
        <React.Fragment>
            <CardWithTitle cardTitle={"Atualização em Massa"}>
                <React.Fragment>
                    <Alert
                        className="mb-3"
                        open={alertVisible}
                        // dismissible={true}
                        theme={alertTheme}
                    >
                        {message}
                    </Alert>
                    <Container>
                        {isFetching ? (
                            <Row>
                                <Col>
                                    <Loading
                                        showBrand={false}
                                        message={"Processando..."}
                                    />
                                </Col>
                            </Row>
                        ) : (
                            <>
                                <Row>
                                    <Col>
                                        <DragNDrop
                                            handleDropData={onXlsxDrop}
                                            title="Arquivo de MiniApps"
                                            backgroundColor="#ccccff"
                                        ></DragNDrop>
                                    </Col>
                                    <Col>
                                        <DragNDrop
                                            handleDropFiles={onXlsxProductDrop}
                                            title="Arquivo de Produtos"
                                            backgroundColor="#ffcccc"
                                        ></DragNDrop>
                                    </Col>
                                </Row>
                                <Row className={"mt-2 mb-3"}>
                                    <Col>
                                        <a
                                            href="/manager/samples/miniapps.xlsx"
                                            title="Arquivo de exemplo"
                                        >
                                            <i className="material-icons">
                                                cloud_download
                                            </i>{" "}
                                            miniapps.xslx
                                        </a>
                                        &nbsp;
                                        <Button onClick={callExportAerosmith}>
                                            Atualizar a Rich Relevance
                                        </Button>
                                    </Col>
                                </Row>
                                {miniAppsToUpdate.map(difference => {
                                    return (
                                        <Row key={difference.current.slug}>
                                            <Col className={"mb-4"}>
                                                <MiniAppTitle
                                                    title={
                                                        difference.current.slug
                                                    }
                                                >
                                                    {difference.current.title}{" "}
                                                    <TitleHelper>
                                                        Será atualizado
                                                    </TitleHelper>
                                                </MiniAppTitle>
                                                <MiniAppDiffTable>
                                                    <thead>
                                                        <tr>
                                                            <th>Atributo</th>
                                                            <th>De</th>
                                                            <th>Para</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Object.keys(
                                                            difference.changes
                                                        ).map(prop => {
                                                            return (
                                                                <tr key={prop}>
                                                                    <td>
                                                                        {prop}
                                                                    </td>
                                                                    <td>
                                                                        <ShowValue
                                                                            value={
                                                                                difference
                                                                                    .handled[
                                                                                    prop
                                                                                ]
                                                                            }
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <ShowValue
                                                                            value={
                                                                                difference
                                                                                    .changes[
                                                                                    prop
                                                                                ]
                                                                            }
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </MiniAppDiffTable>
                                            </Col>
                                        </Row>
                                    );
                                })}
                                {miniAppsToCreate.length > 0 && (
                                    <>
                                        <Row>
                                            <Col>
                                                <h5>Novos MiniApps</h5>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                {miniAppsToCreate.map(
                                                    newMiniApp => {
                                                        return (
                                                            <MiniAppAttributes
                                                                miniApp={
                                                                    newMiniApp
                                                                }
                                                                key={
                                                                    newMiniApp.slug
                                                                }
                                                            />
                                                        );
                                                    }
                                                )}
                                            </Col>
                                        </Row>
                                    </>
                                )}
                                {(miniAppsToUpdate.length > 0 ||
                                    miniAppsToCreate.length > 0) && (
                                    <Row className={"mt-2 mb-3"}>
                                        <Col>
                                            <Button
                                                onClick={
                                                    callBackendToCreateOrUpdate
                                                }
                                            >
                                                Confirmar alterações
                                            </Button>
                                        </Col>
                                    </Row>
                                )}
                                {miniAppsToInform.length > 0 && (
                                    <>
                                        <Row>
                                            <Col>
                                                <h5>
                                                    MiniApps sem alteração{" "}
                                                    <ToggleLink
                                                        onClick={
                                                            toggleShowMiniAppsEq
                                                        }
                                                        show={showMiniAppsEq}
                                                    />
                                                </h5>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                {showMiniAppsEq &&
                                                    miniAppsToInform.map(
                                                        miniAppInfo => {
                                                            return (
                                                                <MiniAppAttributes
                                                                    miniApp={
                                                                        miniAppInfo
                                                                    }
                                                                    key={
                                                                        miniAppInfo.slug
                                                                    }
                                                                />
                                                            );
                                                        }
                                                    )}
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            </>
                        )}
                    </Container>
                </React.Fragment>
            </CardWithTitle>
        </React.Fragment>
    );
};

export default MassiveMiniappUpdate;
